import { animate, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';
import * as fromRoot from '@app/reducers';
import { Device } from '@app/shared/models/device';
import { Store } from '@ngrx/store';
import { ViewerActions } from '../../actions';
import * as fromViewer from '../../reducers/viewer.reducer';
import { hostnameIsFromMainDomain } from '@app/shared/helpers/location';

@Component({
  selector: 'app-download-progress',
  templateUrl: './download-progress.component.html',
  styleUrls: ['./download-progress.component.scss'],
  animations: [
    trigger(
      'fade', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('800ms', style({ opacity: '1' }))
      ]),
    ]
    )
  ],
})
export class DownloadProgressComponent implements OnInit {

  @Input() device: Device;
  @Input() hasPromotion: boolean;

  isMainDomain: boolean;

  constructor(private store$: Store<fromRoot.State & fromViewer.State>) {

    this.isMainDomain = hostnameIsFromMainDomain(window.location.hostname);
  }

  ngOnInit() { }

  backToPreview(): void {
    this.store$.dispatch(ViewerActions.HideDownloadSection());
    this.store$.dispatch(ViewerActions.ResetSelectedFiles());
  }

}
